const setPreview = (preview) => {
    return {
        type: 'SET_PREVIEW_URL',
        payload: preview
    };
};

export default { setPreview };
